// hooks/useTranslation.js
import { useState, useEffect, useCallback } from 'react';
import { defaultLanguage, detectBrowserLanguage, normalizeLanguageCode } from '../config/languages.js';
import { getLanguageFromPath, stripLanguageFromPath } from '../utils/localizedRoutes.js';

// Import common translations
import { navigation } from '../translations/common/navigation.js';
import { cookies } from '../translations/common/cookies.js';

// Import page-specific translations
import { landingPageDE } from '../translations/pages/landing/de.js';
import { landingPageEN } from '../translations/pages/landing/en.js';
import { landingPageNL } from '../translations/pages/landing/nl.js';
import { landingPageUK } from '../translations/pages/landing/uk.js';
import { landingPageFR } from '../translations/pages/landing/fr.js';
import { landingPageIT } from '../translations/pages/landing/it.js';
import { landingPageES } from '../translations/pages/landing/es.js';
import { landingPageSV } from '../translations/pages/landing/sv.js';
import { landingPageFI } from '../translations/pages/landing/fi.js';
import { landingPageJA } from '../translations/pages/landing/ja.js';
import { landingPagePL } from '../translations/pages/landing/pl.js';
import { landingPageBG } from '../translations/pages/landing/bg.js';

import { teamPageDE } from '../translations/pages/team/de.js';
import { teamPageEN } from '../translations/pages/team/en.js';
import { teamPageNL } from '../translations/pages/team/nl.js';
import { teamPageUK } from '../translations/pages/team/uk.js';
import { teamPageFR } from '../translations/pages/team/fr.js';
import { teamPageIT } from '../translations/pages/team/it.js';
import { teamPageES } from '../translations/pages/team/es.js';
import { teamPageSV } from '../translations/pages/team/sv.js';
import { teamPageFI } from '../translations/pages/team/fi.js';
import { teamPageJA } from '../translations/pages/team/ja.js';
import { teamPagePL } from '../translations/pages/team/pl.js';
import { teamPageBG } from '../translations/pages/team/bg.js';

import { financePageDE } from '../translations/pages/finance/de.js';
import { financePageEN } from '../translations/pages/finance/en.js';
import { financePageNL } from '../translations/pages/finance/nl.js';
import { financePageUK } from '../translations/pages/finance/uk.js';
import { financePageFR } from '../translations/pages/finance/fr.js';
import { financePageIT } from '../translations/pages/finance/it.js';
import { financePageES } from '../translations/pages/finance/es.js';
import { financePageSV } from '../translations/pages/finance/sv.js';
import { financePageFI } from '../translations/pages/finance/fi.js';
import { financePageJA } from '../translations/pages/finance/ja.js';
import { financePagePL } from '../translations/pages/finance/pl.js';
import { financePageBG } from '../translations/pages/finance/bg.js';

import { eventsPageDE } from '../translations/pages/events/de.js';
import { eventsPageEN } from '../translations/pages/events/en.js';
import { eventsPageNL } from '../translations/pages/events/nl.js';
import { eventsPageUK } from '../translations/pages/events/uk.js';
import { eventsPageFR } from '../translations/pages/events/fr.js';
import { eventsPageIT } from '../translations/pages/events/it.js';
import { eventsPageES } from '../translations/pages/events/es.js';
import { eventsPageSV } from '../translations/pages/events/sv.js';
import { eventsPageFI } from '../translations/pages/events/fi.js';
import { eventsPageJA } from '../translations/pages/events/ja.js';
import { eventsPagePL } from '../translations/pages/events/pl.js';
import { eventsPageBG } from '../translations/pages/events/bg.js';

import { iddPageDE } from '../translations/pages/idd/de.js';
import { iddPageEN } from '../translations/pages/idd/en.js';
import { iddPageNL } from '../translations/pages/idd/nl.js';
import { iddPageUK } from '../translations/pages/idd/uk.js';
import { iddPageFR } from '../translations/pages/idd/fr.js';
import { iddPageIT } from '../translations/pages/idd/it.js';
import { iddPageES } from '../translations/pages/idd/es.js';
import { iddPageSV } from '../translations/pages/idd/sv.js';
import { iddPageFI } from '../translations/pages/idd/fi.js';
import { iddPageJA } from '../translations/pages/idd/ja.js';
import { iddPagePL } from '../translations/pages/idd/pl.js';
import { iddPageBG } from '../translations/pages/idd/bg.js';

import { veridionPageDE } from '../translations/pages/veridion/de.js';
import { veridionPageEN } from '../translations/pages/veridion/en.js';
import { veridionPageNL } from '../translations/pages/veridion/nl.js';
import { veridionPageUK } from '../translations/pages/veridion/uk.js';
import { veridionPageFR } from '../translations/pages/veridion/fr.js';
import { veridionPageIT } from '../translations/pages/veridion/it.js';
import { veridionPageES } from '../translations/pages/veridion/es.js';
import { veridionPageSV } from '../translations/pages/veridion/sv.js';
import { veridionPageFI } from '../translations/pages/veridion/fi.js';
import { veridionPageJA } from '../translations/pages/veridion/ja.js';
import { veridionPagePL } from '../translations/pages/veridion/pl.js';
import { veridionPageBG } from '../translations/pages/veridion/bg.js';

import { teachingPageDE } from '../translations/pages/teaching/de.js';
import { teachingPageEN } from '../translations/pages/teaching/en.js';
import { teachingPageNL } from '../translations/pages/teaching/nl.js';

import { agenticDevDE } from '../translations/pages/agenticdev/de.js';
import { agenticDevEN } from '../translations/pages/agenticdev/en.js';
import { agenticDevNL } from '../translations/pages/agenticdev/nl.js';

import { kyveilPageDE } from '../translations/pages/kyveil/de.js';
import { kyveilPageEN } from '../translations/pages/kyveil/en.js';
import { kyveilPageNL } from '../translations/pages/kyveil/nl.js';
import { kyveilPageUK } from '../translations/pages/kyveil/uk.js';
import { kyveilPageFR } from '../translations/pages/kyveil/fr.js';
import { kyveilPageIT } from '../translations/pages/kyveil/it.js';
import { kyveilPageES } from '../translations/pages/kyveil/es.js';
import { kyveilPageSV } from '../translations/pages/kyveil/sv.js';
import { kyveilPageFI } from '../translations/pages/kyveil/fi.js';
import { kyveilPageJA } from '../translations/pages/kyveil/ja.js';
import { kyveilPagePL } from '../translations/pages/kyveil/pl.js';
import { kyveilPageBG } from '../translations/pages/kyveil/bg.js';

import { quantumPageDE } from '../translations/pages/quantum/de.js';
import { quantumPageEN } from '../translations/pages/quantum/en.js';
import { quantumPageNL } from '../translations/pages/quantum/nl.js';
import { quantumPageUK } from '../translations/pages/quantum/uk.js';
import { quantumPageFR } from '../translations/pages/quantum/fr.js';
import { quantumPageIT } from '../translations/pages/quantum/it.js';
import { quantumPageES } from '../translations/pages/quantum/es.js';
import { quantumPageSV } from '../translations/pages/quantum/sv.js';
import { quantumPageFI } from '../translations/pages/quantum/fi.js';
import { quantumPageJA } from '../translations/pages/quantum/ja.js';
import { quantumPagePL } from '../translations/pages/quantum/pl.js';
import { quantumPageBG } from '../translations/pages/quantum/bg.js';

import { privacyPageDE } from '../translations/pages/privacy/de.js';
import { privacyPageEN } from '../translations/pages/privacy/en.js';
import { privacyPageNL } from '../translations/pages/privacy/nl.js';
import { privacyPageUK } from '../translations/pages/privacy/uk.js';
import { privacyPageFR } from '../translations/pages/privacy/fr.js';
import { privacyPageIT } from '../translations/pages/privacy/it.js';
import { privacyPageES } from '../translations/pages/privacy/es.js';
import { privacyPageSV } from '../translations/pages/privacy/sv.js';
import { privacyPageFI } from '../translations/pages/privacy/fi.js';
import { privacyPageJA } from '../translations/pages/privacy/ja.js';
import { privacyPagePL } from '../translations/pages/privacy/pl.js';
import { privacyPageBG } from '../translations/pages/privacy/bg.js';
import { aiTransparencyPageDE } from '../translations/pages/aitransparency/de.js';
import { aiTransparencyPageEN } from '../translations/pages/aitransparency/en.js';
import { aiTransparencyPageNL } from '../translations/pages/aitransparency/nl.js';
import { aiTransparencyPageUK } from '../translations/pages/aitransparency/uk.js';
import { aiTransparencyPageFR } from '../translations/pages/aitransparency/fr.js';
import { aiTransparencyPageIT } from '../translations/pages/aitransparency/it.js';
import { aiTransparencyPageES } from '../translations/pages/aitransparency/es.js';
import { aiTransparencyPageSV } from '../translations/pages/aitransparency/sv.js';
import { aiTransparencyPageFI } from '../translations/pages/aitransparency/fi.js';
import { aiTransparencyPageJA } from '../translations/pages/aitransparency/ja.js';
import { aiTransparencyPagePL } from '../translations/pages/aitransparency/pl.js';
import { aiTransparencyPageBG } from '../translations/pages/aitransparency/bg.js';

import { impressumPageDE } from '../translations/pages/impressum/de.js';
import { impressumPageEN } from '../translations/pages/impressum/en.js';
import { impressumPageNL } from '../translations/pages/impressum/nl.js';

import { localeUK } from '../translations/locales/uk.js';
import { localeFR } from '../translations/locales/fr.js';
import { localeIT } from '../translations/locales/it.js';
import { localeES } from '../translations/locales/es.js';
import { localeSV } from '../translations/locales/sv.js';
import { localeFI } from '../translations/locales/fi.js';
import { localeJA } from '../translations/locales/ja.js';
import { localePL } from '../translations/locales/pl.js';
import { localeBG } from '../translations/locales/bg.js';

// Pages that carry one file per language are merged over the locale's own pages.
const withPages = (locale, pages) => ({
  ...locale,
  pages: {
    ...locale.pages,
    ...pages
  }
});

// Master translation object
const translations = {
  de: {
    ...navigation.de,
    ...cookies.de,
    pages: {
      landing: landingPageDE,
      events: eventsPageDE,
      team: teamPageDE,
      finance: financePageDE,
      teaching: teachingPageDE,
      agenticdev: agenticDevDE,
      idd: iddPageDE,
      veridion: veridionPageDE,
      kyveil: kyveilPageDE,
      quantum: quantumPageDE,
      privacy: privacyPageDE,
      aiTransparency: aiTransparencyPageDE,
      impressum: impressumPageDE
    }
  },
  en: {
    ...navigation.en,
    ...cookies.en,
    pages: {
      landing: landingPageEN,
      events: eventsPageEN,
      team: teamPageEN,
      finance: financePageEN,
      teaching: teachingPageEN,
      agenticdev: agenticDevEN,
      idd: iddPageEN,
      veridion: veridionPageEN,
      kyveil: kyveilPageEN,
      quantum: quantumPageEN,
      privacy: privacyPageEN,
      aiTransparency: aiTransparencyPageEN,
      impressum: impressumPageEN
    }
  },
  nl: {
    ...navigation.nl,
    ...cookies.nl,
    pages: {
      landing: landingPageNL,
      events: eventsPageNL,
      team: teamPageNL,
      finance: financePageNL,
      teaching: teachingPageNL,
      agenticdev: agenticDevNL,
      idd: iddPageNL,
      veridion: veridionPageNL,
      kyveil: kyveilPageNL,
      quantum: quantumPageNL,
      privacy: privacyPageNL,
      aiTransparency: aiTransparencyPageNL,
      impressum: impressumPageNL
    }
  },
  uk: withPages(localeUK, { landing: landingPageUK, events: eventsPageUK, team: teamPageUK, finance: financePageUK, kyveil: kyveilPageUK, quantum: quantumPageUK, idd: iddPageUK, veridion: veridionPageUK, privacy: privacyPageUK, aiTransparency: aiTransparencyPageUK }),
  fr: withPages(localeFR, { landing: landingPageFR, events: eventsPageFR, team: teamPageFR, finance: financePageFR, kyveil: kyveilPageFR, quantum: quantumPageFR, idd: iddPageFR, veridion: veridionPageFR, privacy: privacyPageFR, aiTransparency: aiTransparencyPageFR }),
  it: withPages(localeIT, { landing: landingPageIT, events: eventsPageIT, team: teamPageIT, finance: financePageIT, kyveil: kyveilPageIT, quantum: quantumPageIT, idd: iddPageIT, veridion: veridionPageIT, privacy: privacyPageIT, aiTransparency: aiTransparencyPageIT }),
  es: withPages(localeES, { landing: landingPageES, events: eventsPageES, team: teamPageES, finance: financePageES, kyveil: kyveilPageES, quantum: quantumPageES, idd: iddPageES, veridion: veridionPageES, privacy: privacyPageES, aiTransparency: aiTransparencyPageES }),
  sv: withPages(localeSV, { landing: landingPageSV, events: eventsPageSV, team: teamPageSV, finance: financePageSV, kyveil: kyveilPageSV, quantum: quantumPageSV, idd: iddPageSV, veridion: veridionPageSV, privacy: privacyPageSV, aiTransparency: aiTransparencyPageSV }),
  fi: withPages(localeFI, { landing: landingPageFI, events: eventsPageFI, team: teamPageFI, finance: financePageFI, kyveil: kyveilPageFI, quantum: quantumPageFI, idd: iddPageFI, veridion: veridionPageFI, privacy: privacyPageFI, aiTransparency: aiTransparencyPageFI }),
  ja: withPages(localeJA, { landing: landingPageJA, events: eventsPageJA, team: teamPageJA, finance: financePageJA, kyveil: kyveilPageJA, quantum: quantumPageJA, idd: iddPageJA, veridion: veridionPageJA, privacy: privacyPageJA, aiTransparency: aiTransparencyPageJA }),
  pl: withPages(localePL, { landing: landingPagePL, events: eventsPagePL, team: teamPagePL, finance: financePagePL, kyveil: kyveilPagePL, quantum: quantumPagePL, idd: iddPagePL, veridion: veridionPagePL, privacy: privacyPagePL, aiTransparency: aiTransparencyPagePL }),
  bg: withPages(localeBG, { landing: landingPageBG, events: eventsPageBG, team: teamPageBG, finance: financePageBG, kyveil: kyveilPageBG, quantum: quantumPageBG, idd: iddPageBG, veridion: veridionPageBG, privacy: privacyPageBG, aiTransparency: aiTransparencyPageBG })
};

const fallbackTranslations = translations[defaultLanguage];

const mergeWithFallback = (value, fallback) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return value || fallback;
  }

  const merged = { ...fallback, ...value };
  Object.keys(fallback || {}).forEach((key) => {
    if (typeof fallback[key] === 'object' && !Array.isArray(fallback[key])) {
      merged[key] = mergeWithFallback(value[key], fallback[key]);
    }
  });
  return merged;
};

// Page mapping for automatic detection
const pageMapping = {
  '/': 'landing',
  '/team': 'team',
  '/events': 'events',
  '/finance': 'finance',
  '/teaching': 'teaching',
  '/agenticdev': 'agenticdev',
  '/veridion': 'veridion',
  '/kyveil': 'kyveil',
  '/quantum': 'quantum',
  '/privacy': 'privacy',
  '/ai-transparency': 'aiTransparency',
  '/impressum': 'impressum',
  '/account': 'account',
  '/admin': 'admin',
  '/admin/azurite': 'admin',
  '/admin/veridion': 'admin',
  '/admin/veridion-paioneer': 'admin',
  '/admin/memory': 'admin',
  '/admin/agentic-rag': 'admin'
};

// GLOBAL STATE for Language
let globalLanguage = defaultLanguage;
let globalListeners = new Set();

// Event emitter for language changes
const emitLanguageChange = (newLang) => {
  globalLanguage = newLang;
  globalListeners.forEach(listener => listener(newLang));
};

export const useTranslation = (forcePage = null) => {
  // Initialize language from localStorage or browser
  const [currentLang, setCurrentLangState] = useState(() => {
    if (typeof window !== 'undefined') {
      const pathLanguage = getLanguageFromPath(window.location.pathname);
      if (pathLanguage) {
        globalLanguage = pathLanguage;
        return pathLanguage;
      }

      const stored = normalizeLanguageCode(localStorage.getItem('language'));
      if (stored) {
        globalLanguage = stored;
        return stored;
      }
      const detectedLang = detectBrowserLanguage();
      globalLanguage = detectedLang;
      return detectedLang;
    }
    return defaultLanguage;
  });

  const [currentPage, setCurrentPage] = useState('landing');
  const [, forceUpdate] = useState({});

  // Force re-render when language changes globally
  useEffect(() => {
    const listener = (newLang) => {
      setCurrentLangState(newLang);
      forceUpdate({}); // Force re-render
    };
    
    globalListeners.add(listener);
    
    return () => {
      globalListeners.delete(listener);
    };
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = currentLang;
    }
  }, [currentLang]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const pathLanguage = getLanguageFromPath(window.location.pathname);
    if (pathLanguage && pathLanguage !== globalLanguage) {
      localStorage.setItem('language', pathLanguage);
      emitLanguageChange(pathLanguage);
    }
  }, []);

  // Update current page based on URL
  useEffect(() => {
    if (typeof window !== 'undefined' && !forcePage) {
      const path = stripLanguageFromPath(window.location.pathname);
      const page = pageMapping[path] || 'landing';
      setCurrentPage(page);
    } else if (forcePage) {
      setCurrentPage(forcePage);
    }
  }, [forcePage]);

  const setLanguage = useCallback((lang) => {
    const normalized = normalizeLanguageCode(lang);
    if (typeof window !== 'undefined' && normalized) {
      localStorage.setItem('language', normalized);
      emitLanguageChange(normalized);
    }
  }, []);

  // Get common translations with fallback
  const getCommonTranslations = useCallback(() => {
    const lang = globalLanguage;
    return {
      nav: mergeWithFallback(translations[lang]?.nav, fallbackTranslations.nav),
      footer: mergeWithFallback(translations[lang]?.footer, fallbackTranslations.footer),
      auth: mergeWithFallback(translations[lang]?.auth, fallbackTranslations.auth),
      admin: mergeWithFallback(translations[lang]?.admin, fallbackTranslations.admin),
      account: mergeWithFallback(translations[lang]?.account, fallbackTranslations.account),
      cookies: mergeWithFallback(translations[lang]?.cookies, fallbackTranslations.cookies)
    };
  }, []);

  // Get page-specific translations with fallback
  const getPageTranslations = useCallback((page = currentPage) => {
    const lang = globalLanguage;
    return translations[lang]?.pages?.[page] || fallbackTranslations.pages?.[page] || {};
  }, [currentPage]);

  // Combined translation object
  const t = {
    ...getCommonTranslations(),
    ...getPageTranslations()
  };

  return {
    t,
    setLanguage,
    currentLang: globalLanguage,
    currentPage,
    getPageTranslations,
    getCommonTranslations
  };
};

// Hook for specific page translations (useful for page components)
export const usePageTranslations = (pageName) => {
  const { getPageTranslations } = useTranslation();
  return getPageTranslations(pageName);
};

export default useTranslation;
